import React from 'react';
import SupplyChainMap from '../../../../../../../components/dashboards/components/SupplyChainMap';

const SourceOfInformation = (props) => {
  return (
    <SupplyChainMap
      {...props}
      title='Identified Trade Relationships'
      type="default"
    />
  );
};

export default SourceOfInformation;
